const getSelectedForTableSearch = (allData = []) => (selected) => {
  if (!selected || selected === 'ALL') return allData;

  return [selected];
};

export default getSelectedForTableSearch;
